import { createApp } from 'vue'
import App  from "./vue/App";
import store from "./store";

export  //ChatbotInit
//{
    function initChatbot()
    {

/*console.log(("%cdom ready for chatbot", "color: orange; font-size: 1.5em;"))*/;
        const app = createApp(App);
        app
            .use(store)
            .provide("chatbot", chatbot) //inject in JS from PHP
            .provide("copydeck", copydeck) //inject in JS from PHP
            .mount('#chatbot');

        window.chatbot = app;

/*console.log(("%cchatbot created", "color: yellow; font-size: 1.5em;"))*/;

    }
//}


//document.addEventListener('DOMContentLoaded', onReadyForChatbot);
/*console.log(("%cchatbot about to be created", "color: green; font-size: 1.5em;"))*/;

